import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  Label,
  FormGroup
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { toast } from "react-toastify";

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import bell from "../../assets/images/svg/bell.svg";

import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import companyImg from "../../assets/images/users/logo-sm.png";

import { api } from "../../config";
import io from "socket.io-client";

import {
  getNotifications as onGetNotifications,
  updateNotification as onGetUpdateNotification,
  getUsers as onGetUsers,
} from "../../slices/thunks";

import { hasPermission } from "../../config/permissions";

//SimpleBar
import SimpleBar from "simplebar-react";
import axios from "axios";
import { APIClient } from "../../helpers/api_helper";
const apiClient = new APIClient();

const NotificationDropdown = () => {
  const dispatch = useDispatch();

  const authUser = JSON.parse(localStorage.getItem("authUser"));

  const [notificationsList, setNotificationsList] = useState([]);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const [activeTab, setActiveTab] = useState("1");
  const [prevUnreadCount, setPrevUnreadCount] = useState(0);
  const [soundAllowed, setSoundAllowed] = useState(false);

  // Alert popup states
  const [alertModal, setAlertModal] = useState(false);
  const [currentAlert, setCurrentAlert] = useState(null);
  const [fbText, setFbText] = useState("");
  const [pollOpt, setPollOpt] = useState("");

  const prevUnreadCountRef = useRef(0);

  useEffect(() => {
    if (currentAlert && authUser) {
      const myR = currentAlert.recipients?.find(r => r.userId.toString() === authUser._id.toString());
      if (myR && myR.isRead) {
        setFbText(myR.responseText || "");
        setPollOpt(myR.selectedOption || "");
      } else {
        setFbText("");
        setPollOpt("");
      }
    }
  }, [currentAlert, authUser?._id]);

  const handleAcknowledgeAlert = async () => {
    if (!currentAlert || !currentAlert._id) return;

    // Determine if we need to call /respond or standard update string
    const isSpecialType = ["feedback", "poll"].includes(currentAlert.ntf_type);

    if (isSpecialType) {
      const payload = {
        ntfId: currentAlert._id,
        responseText: currentAlert.ntf_type === "feedback" ? fbText : undefined,
        selectedOption: currentAlert.ntf_type === "poll" ? pollOpt : undefined,
      };
      try {
        await axios.put(api.REAPI_URL + "/notifications/respond", payload, {
          headers: {
            "token": "Bearer " + (authUser?.accessToken || "")
          }
        });
        // Clear locally from redux
        dispatch(onGetUpdateNotification({ ids: [currentAlert._id] }));
      } catch (err) {
        console.error("Error submitting feedback:", err);
      }
    } else {
      dispatch(onGetUpdateNotification({ ids: [currentAlert._id] }));
    }

    setAlertModal(false);
    setFbText("");
    setPollOpt("");
  };

  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const toggleNotificationDropdown = () => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  const selectNotificationLayoutState = (state) => state.Notification;
  const notificationData = createSelector(
    selectNotificationLayoutState,
    (state) => ({
      notifications: state.notifications,
      isNotificationsSuccess: state.isNotificationsSuccess,
      error: state.error,
    })
  );

  const { notifications, isNotificationsSuccess, error } =
    useSelector(notificationData);

  const selectLayoutState = (state) => state.Crm;
  const crmuserData = createSelector(selectLayoutState, (state) => ({
    crmusers: state.crmusers,
    isUserSuccess: state.isUserSuccess,
    error: state.error,
  }));

  const { crmusers, isUserSuccess } = useSelector(crmuserData);

  useEffect(() => {
    if (crmusers && !crmusers.length) {
      dispatch(onGetUsers());
    }
  }, [dispatch, crmusers]);

  useEffect(() => {
    const getTunnel = () => {
      if (authUser?.company === "TILogistic") {
        if (authUser?.section === "Санхүүгийн хэлтэс") {
          return "Тээврийн газар";
        } else if (
          authUser?.role === "Ахлах гаалийн бүртгэгдсэн мэргэжилтэн" ||
          authUser?.role === "Гаалийн бүртгэгдсэн мэргэжилтэн"
        ) {
          return "Тээврийн газар";
        } else {
          return authUser?.department || "null";
        }
      }

      if (authUser?.type === "Терминалын газрын хэрэглэгч") {
        return "Терминалын газар";
      }

      if (authUser?.type === "Тээврийн газрын хэрэглэгч") {
        return "Тээврийн газар";
      }

      return "null";
    };

    const fetchNotifications = () => {
      const tunnel = getTunnel();

      dispatch(
        onGetNotifications({
          ntf_tunnel: tunnel,
        })
      );
    };

    fetchNotifications();

    // Socket.io Integration
    const socketUrl = new URL(api.REAPI_URL).origin;
    const socket = io(socketUrl, {
      path: "/api/socket.io",
      withCredentials: true,
    });

    socket.on("connect", () => {
      if (authUser && authUser._id) {
        socket.emit("registerUser", authUser._id);
      }
    });

    socket.on("newNotification", (ntf) => {
      // Whenever backend pushes a notification we fetch newest
      fetchNotifications();
    });

    return () => {
      socket.disconnect();
    };
  }, [dispatch, authUser?._id, authUser?.company, authUser?.department, authUser?.type]);

  useEffect(() => {
    const handleUserInteraction = () => setSoundAllowed(true);
    document.addEventListener("click", handleUserInteraction, { once: true });
    return () => document.removeEventListener("click", handleUserInteraction);
  }, []);

  useEffect(() => {
    if (Array.isArray(notifications) && authUser) {
      const enrichedNotifications = notifications
        .filter((ntf) => ntf.sender_id !== authUser._id || ntf.recipients.some(r => r.userId.toString() === authUser._id.toString()))
        .map((ntf) => {
          let senderName = ntf.sender_company || "N/A";
          let senderImage = companyImg;

          const isPrivilegedUser =
            hasPermission(authUser.role, "NOTIFICATION_PRIVILEGED_USERS") ||
            authUser.department === "Тээврийн газар" ||
            authUser.section === "Санхүүгийн хэлтэс" ||
            (authUser.notification_tunnels && authUser.notification_tunnels.length > 0);

          if (isPrivilegedUser) {
            if (ntf.sender_company !== "TILogistic") {
              senderName = ntf.sender_company || "N/A";
              senderImage = ntf.sender_image_url || dummyImg;
            } else {
              senderName = `${ntf.sender_last_name?.charAt(0).toUpperCase() || ""}.${ntf.sender_first_name || ""
                } | ${ntf.sender_company || "TILogistic"}`;
              senderImage = ntf.sender_image_url || dummyImg;
            }
          }

          return {
            ...ntf,
            sender_image: senderImage,
            sender_name: senderName,
          };
        });

      const unreadCount = enrichedNotifications.filter((ntf) =>
        ntf.recipients.some(
          (r) => r.userId.toString() === authUser._id.toString() && !r.isRead
        )
      ).length;

      if (unreadCount > prevUnreadCountRef.current) {
        // Check for unread warnings
        const unreadWarnings = enrichedNotifications.filter(
          (ntf) =>
            ["warning", "feedback", "poll"].includes(ntf.ntf_type) &&
            ntf.recipients.some(
              (r) => r.userId.toString() === authUser._id.toString() && !r.isRead
            )
        );

        if (unreadWarnings.length > 0) {
          setCurrentAlert(unreadWarnings[0]);
          setAlertModal(true);
        } else {
          toast.info(
            `Шинэ мэдэгдэл ирлээ! (${unreadCount - prevUnreadCountRef.current})`,
            {
              autoClose: 5000,
              closeButton: ({ closeToast }) => (
                <button
                  onClick={closeToast}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#1077d8ff",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                >
                  ✖
                </button>
              ),
            }
          );
        }
      }

      if (unreadCount > prevUnreadCountRef.current && soundAllowed) {
        const audio = new Audio("/sounds/notification.mp3");
        audio.play().catch((err) => console.log("Sound play error:", err));
      }

      prevUnreadCountRef.current = unreadCount;
      setUnreadNotificationsCount(unreadCount);
      setNotificationsList(enrichedNotifications);
    }
  }, [notifications, authUser, soundAllowed]);

  const msgNtfs = notificationsList.filter(ntf => !["warning", "feedback", "poll"].includes(ntf.ntf_type));
  const alertNtfs = notificationsList.filter(ntf => ["warning", "feedback", "poll"].includes(ntf.ntf_type));

  const formatNotificationDate = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);

    const diffMs = now - date;
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);

    if (diffHours < 12) {
      if (diffHours > 0) {
        return `${diffHours} цагийн өмнө`;
      } else if (diffMinutes > 0) {
        return `${diffMinutes} минутын өмнө`;
      } else {
        return `${diffSeconds} секундын өмнө`;
      }
    }

    // YYYY-MM-DD, HH:mm форматаар буцаах
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}, ${hours}:${minutes}`;
  };

  const handleDropdownOpen = () => {
    setSoundAllowed(true);
  };

  const markAllAsRead = (e) => {
    e.stopPropagation();

    const unreadIds = notificationsList
      ?.filter((ntf) =>
        ntf.recipients.some(
          (r) => r.userId.toString() === authUser._id.toString() && r.isRead === false
        )
      )
      .map((ntf) => ntf._id);

    if (unreadIds?.length > 0) {
      dispatch(onGetUpdateNotification({ ids: unreadIds }));
      setUnreadNotificationsCount(0);
      setNotificationsList(prevList => prevList.map(ntf => {
        if (unreadIds.includes(ntf._id)) {
          return {
            ...ntf,
            recipients: ntf.recipients.map(r =>
              r.userId.toString() === authUser._id.toString() ? { ...r, isRead: true } : r
            )
          };
        }
        return ntf;
      }));
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isNotificationDropdown}
        toggle={toggleNotificationDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
          onClick={handleDropdownOpen}
        >
          <i className="bx bx-bell fs-22"></i>
          <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-info">
            {unreadNotificationsCount || 0}
            <span className="visually-hidden">уншаагүй мэдэгдэл</span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="dropdown-head bg-primary bg-pattern rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white">
                    {" "}
                    Мэдэгдэл{" "}
                  </h6>
                </Col>
                <div className="col-auto dropdown-tabs">
                  <span
                    className="badge bg-light-subtle text-body fs-13"
                    onClick={markAllAsRead}
                    style={{ cursor: "pointer" }}
                    title="Бүгдийг уншсанаар тэмдэглэх"
                  >
                    <i className="ri-check-double-line align-middle me-1 text-success"></i>
                    Бүгдийг унших ({unreadNotificationsCount || 0})
                  </span>
                </div>
              </Row>
            </div>

            <div className="px-2 pt-2">
              <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    Нийт
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    Мэдэгдэл
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggleTab("3");
                    }}
                  >
                    Чухал мэдэгдэл
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {notificationsList && notificationsList.length > 0 ? (
                  notificationsList.map((ntf) => (
                    <div
                      key={ntf._id}
                      className="text-reset notification-item d-block dropdown-item position-relative"
                    >
                      <div className="d-flex">
                        <img
                          src={ntf?.sender_image || dummyImg}
                          className="me-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                            {ntf?.sender_name || "Unknown"}
                          </h6>
                          <div className="fs-13 text-muted">
                            <p
                              className={`mb-1 ${ntf.recipients.some(
                                (r) =>
                                  r.userId.toString() ===
                                  authUser._id.toString() && !r.isRead
                              )
                                  ? "text-info"
                                  : "text-muted"
                                }`}
                            >
                              {ntf.ntf_body}
                            </p>
                          </div>

                          <p className="mb-0 fs-11 fw-medium text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i>{" "}
                              {formatNotificationDate(ntf.ntf_date)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                      <img
                        src={bell}
                        className="img-fluid"
                        alt="no-notification"
                      />
                    </div>
                    <div className="text-center pb-5 mt-2">
                      <h6 className="fs-18 fw-semibold lh-base">
                        Танд ирсэн мэдэгдэл байхгүй байна
                      </h6>
                    </div>
                  </>
                )}
              </SimpleBar>
            </TabPane>

            <TabPane tabId="2" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {msgNtfs && msgNtfs.length > 0 ? (
                  msgNtfs.map((ntf) => (
                    <div
                      key={ntf._id}
                      className="text-reset notification-item d-block dropdown-item position-relative"
                    >
                      <div className="d-flex">
                        <img
                          src={ntf?.sender_image || dummyImg}
                          className="me-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                            {ntf?.sender_name || "Unknown"}
                          </h6>
                          <div className="fs-13 text-muted">
                            <p
                              className={`mb-1 ${ntf.recipients.some(
                                (r) =>
                                  r.userId.toString() ===
                                  authUser._id.toString() && !r.isRead
                              )
                                  ? "text-info"
                                  : "text-muted"
                                }`}
                            >
                              {ntf.ntf_body}
                            </p>
                          </div>

                          <p className="mb-0 fs-11 fw-medium text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i>{" "}
                              {formatNotificationDate(ntf.ntf_date)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                      <img
                        src={bell}
                        className="img-fluid"
                        alt="no-notification"
                      />
                    </div>
                    <div className="text-center pb-5 mt-2">
                      <h6 className="fs-18 fw-semibold lh-base">
                        Танд ирсэн мэдэгдэл байхгүй байна
                      </h6>
                    </div>
                  </>
                )}
              </SimpleBar>
            </TabPane>
            <TabPane tabId="3" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {alertNtfs && alertNtfs.length > 0 ? (
                  alertNtfs.map((ntf) => (
                    <div
                      key={ntf._id}
                      className="text-reset notification-item d-block dropdown-item position-relative bg-info-subtle"
                      onClick={() => {
                        setCurrentAlert(ntf);
                        setAlertModal(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex">
                        <img
                          src={ntf?.sender_image || dummyImg}
                          className="me-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1 fs-13 fw-semibold text-info">
                            {ntf?.sender_name || "Unknown"}
                          </h6>
                          <div className="fs-13 text-muted">
                            <p
                              className={`mb-1 fw-bold ${ntf.recipients.some(
                                (r) =>
                                  r.userId.toString() ===
                                  authUser._id.toString() && !r.isRead
                              )
                                  ? "text-primary"
                                  : "text-dark"
                                }`}
                            >
                              {ntf.ntf_body}
                            </p>
                          </div>

                          <p className="mb-0 fs-11 fw-medium text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i>{" "}
                              {formatNotificationDate(ntf.ntf_date)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                      <img src={bell} className="img-fluid" alt="user-pic" />
                    </div>
                    <div className="text-center pb-5 mt-2">
                      <h6 className="fs-18 fw-semibold lh-base">
                        Танд ирсэн чухал мэдэгдэл байхгүй байна{" "}
                      </h6>
                    </div>
                  </>
                )}
              </SimpleBar>
            </TabPane>
          </TabContent>
        </DropdownMenu>
      </Dropdown>

      {/* Warning Popup Modal */}
      <Modal
        isOpen={alertModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={() => setAlertModal(false)} className="bg-info-subtle text-info border-bottom-0 pb-3">
          <span className="fs-15 fw-semibold"><i className="ri-information-line me-1 align-bottom"></i> Чухал мэдэгдэл</span>
        </ModalHeader>
        <ModalBody className="text-center p-4">
          <div className="mt-2">
            <i className="ri-information-fill text-info display-4"></i>
            <h4 className="mb-3 mt-4 fw-semibold text-dark">{currentAlert?.ntf_title || "ЧУХАЛ МЭДЭГДЭЛ"}</h4>
            <p className="text-muted fs-15 mb-4">{currentAlert?.ntf_body}</p>
            <div className="mb-4">
              {currentAlert?.ntf_type === "feedback" && (
                <div className="text-start mt-3">
                  <Label className="fw-medium text-dark">Таны санал хүсэлт:</Label>
                  <Input
                    type="textarea"
                    rows="3"
                    placeholder="Энд бичнэ үү..."
                    value={fbText}
                    onChange={(e) => setFbText(e.target.value)}
                    disabled={currentAlert.recipients?.find(r => r.userId === authUser._id)?.isRead}
                  />
                </div>
              )}
              {currentAlert?.ntf_type === "poll" && currentAlert?.pollOptions?.length > 0 && (
                <div className="text-start mt-3">
                  <Label className="fw-medium text-dark">Хариулт сонгох:</Label>
                  <div className="d-flex flex-column gap-2 mt-2">
                    {currentAlert.pollOptions.map((opt, i) => (
                      <FormGroup check key={i}>
                        <Input
                          type="radio"
                          name="pollOptionsRad"
                          id={`pollOpt_${i}`}
                          value={opt}
                          checked={pollOpt === opt}
                          onChange={(e) => setPollOpt(e.target.value)}
                          disabled={currentAlert.recipients?.find(r => r.userId === authUser._id)?.isRead}
                        />
                        <Label check htmlFor={`pollOpt_${i}`}>{opt}</Label>
                      </FormGroup>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="hstack gap-2 justify-content-center">
              {currentAlert?.recipients?.find(r => r.userId === authUser?._id)?.isRead ? (
                <Button color="light" size="lg" onClick={() => setAlertModal(false)}>
                  <i className="ri-close-line align-middle me-1"></i> Хаах
                </Button>
              ) : (
                <Button color="info" size="lg" onClick={handleAcknowledgeAlert}>
                  <i className="ri-check-double-line align-middle me-1"></i> {["feedback", "poll"].includes(currentAlert?.ntf_type) ? "Илгээх & Танилцах" : "Мэдэгдэлтэй танилцсан"}
                </Button>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default NotificationDropdown;
